import React from 'react'
import PropTypes from 'prop-types'
import { GamePageTemplate } from '../../templates/game-page'

const GamePagePreview = ({ entry, getAsset, widgetFor }) => {
  const entryBlurbs = entry.getIn(['data', 'intro', 'blurbs'])
  const blurbs = entryBlurbs ? entryBlurbs.toJS() : []


  return (
    <GamePageTemplate
      image={getAsset(entry.getIn(['data', 'image']))}
      title={entry.getIn(['data', 'title'])}
      heading={entry.getIn(['data', 'heading'])}
      description={entry.getIn(['data', 'description'])}
      intro={{ 
        blurbs: blurbs
      }}
      content={widgetFor('body')}
    />
  )
}

GamePagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  getAsset: PropTypes.func,
  widgetFor: PropTypes.func,
}

export default GamePagePreview
